import React, {useEffect, useState} from 'react';
import {Accordion, Row, Col, Form} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from './IconButton';
import {listUserClub} from '../../lib/api/club';
import {listSelection , listGender} from '../../lib/api/player';

const SearchCoachAccordion = ({handleSearch, handleExport}) => {

    const [search, setSearch] = useState({});
    const [selection, setSelection] = useState([]);
    const [clubs, setClubs] = useState([]);
    const [gender, setGender] = useState([]);

    const handleInputChange = e => {
        const { name, value } = e.target;

        console.log('name', name, value);

        setSearch(prev => {
            const updated = { ...prev };
            console.log('updated',updated)
            if (value === '') {
                delete updated[name]; // obriši polje ako je prazno
            } else {
                updated[name] = value;
            }
            return updated;
        });
    };



    // const handleInputSearch = e => {
    //     handleSearch(search)
    // };

    useEffect(() => {
        (async () => {

            console.log('Search state changed:', search);

            try {
                const rowSelectionRaw = await listSelection();
                const rowSelection = rowSelectionRaw.filter(item => item.selection_id !== 4);
                setSelection(rowSelection);

                const rowClubs = await listUserClub()
                setClubs(rowClubs);

                const rowGender = await listGender()
                setGender(rowGender);

            } catch (error) {
            }
        })();
    }, []);

    return (
        <Accordion defaultActiveKey={null}>
            <Accordion.Item eventKey="0">
                <Accordion.Header><FontAwesomeIcon icon="search" className="fs-10 me-2" /><strong>Pretraga</strong></Accordion.Header>
                <Accordion.Body>
                    <Form.Group as={Col} md="12" method="POST" encType="multipart/form-data" noValidate>
                        <Row className="flex-between-center mb-3">
                            <Col md={12}>
                                <Form.Label>Naziv</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="t_name"
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                        <Row className="flex-between-center mb-3">
                            <Col md="12" className="text-end mt-2">
                                <IconButton
                                    className="rounded-pill me-1 mb-1"
                                    variant="falcon-primary"
                                    icon="search"
                                    transform="shrink-3"
                                    onClick={() => handleSearch(search)}
                                >
                                    Pretraga
                                </IconButton>
                            </Col>
                        </Row>
                    </Form.Group>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
};

export default SearchCoachAccordion;
